interface BookInterface {
    id: number;
    name: string;
    course?: string;
}

export default class Book implements BookInterface {
    id = -1
    name = ''
    course = ''
}
